import cloneDeep from 'lodash/fp/cloneDeep'
import {
  SERVICE_SELECTED
  , INVESTOR_DESCRIPTION_SELECTED
  , KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED
  , MONTHLY_INVESTMENT_AMOUNT_SELECTED
  , ONCE_OFF_INVESTMENT_AMOUNT_SELECTED
  , PREFERRED_LANGUAGE_SELECTED
  , SEARCH_CRITERIA_CLEAR_ALL
  , SEARCH_CRITERIA_SET_USER_ADDRESS,
  actions as searchCriteriaActions
} from './searchCriteriaActions'

const initialState = {
  financialServices: [],
  investorDescriptionId: null,
  selectedInvestmentAmount: null,
  selectedInvestorDescriptionId: null,
  selectedKnowsHowMuchToInvestOptionId: null,
  selectedPreferredLanguageIds: [],
  investmentAmounts: {
    onceOffAmount: 0,
    monthlyAmount: 0
  },
  userAddress: '',
  searchCriteriaChanged: false,
  shouldRefreshResults: true,
  matchingProfiles: 0,
  fetchingProfileMatches: false
}

export default function (state = initialState, action) {
  var oldState = state
  var newState = cloneDeep(state)
  switch (action.type) {
    case searchCriteriaActions.set.resultsRefreshed:
      newState.shouldRefreshResults = action.resultsRefreshed || false
      return newState
    case searchCriteriaActions.fetched.profileMatches:
      newState.fetchingProfileMatches = false
      newState.matchingProfiles = action.payload[0]?.totalProfileMatches
      return newState
    case searchCriteriaActions.fetching.profileMatches:
      newState.fetchingProfileMatches = true
      newState.searchCriteriaChanged = false
      newState.shouldRefreshResults = true
      return newState
    case SEARCH_CRITERIA_SET_USER_ADDRESS:
      newState.userAddress = action.userAddress
      newState.searchCriteriaChanged = true
      return newState
    case MONTHLY_INVESTMENT_AMOUNT_SELECTED:
      newState.investmentAmounts.monthlyAmount = action.monthlyInvestmentAmount
      newState.searchCriteriaChanged = true
      return newState
    case ONCE_OFF_INVESTMENT_AMOUNT_SELECTED:
      newState.investmentAmounts.onceOffAmount = action.onceOffInvestmentAmount
      newState.searchCriteriaChanged = true
      return newState
    case PREFERRED_LANGUAGE_SELECTED: {
      var selectedLanguageId = parseInt(action.languageId)
      const alreadySelected = state.selectedPreferredLanguageIds.includes(selectedLanguageId)
      return {
        ...state,
        selectedPreferredLanguageIds: alreadySelected
          ? state.selectedPreferredLanguageIds.filter(id => id !== selectedLanguageId)
          : [...state.selectedPreferredLanguageIds, selectedLanguageId],
        searchCriteriaChanged: true
      }
      return nextState
    }
    case KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED:
      newState.selectedKnowsHowMuchToInvestOptionId = parseInt(action.knowsHowMuchToInvestOptionId)
      newState.searchCriteriaChanged = true
      return newState
    case SERVICE_SELECTED:
      var financialServiceId = parseInt(action.financialServiceId)
      const alreadySelected = state.financialServices.includes(financialServiceId)

      return {
        ...state,
        financialServices: alreadySelected
          ? state.financialServices.filter(id => id !== financialServiceId)
          : [...state.financialServices, financialServiceId],
        searchCriteriaChanged: true
      }
    case INVESTOR_DESCRIPTION_SELECTED:
      var investorDescriptionId = parseInt(action.investorDescriptionId)
      newState.investorDescriptionId = investorDescriptionId
      newState.searchCriteriaChanged = true
      return newState
    case SEARCH_CRITERIA_CLEAR_ALL:
      return cloneDeep(initialState)
  }
  return state
}
